import { TitleAndTable } from "components/Common"
import { ModuleIds } from "constant"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
//i18n
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getAuditLog } from "store/actions"
import AuditLogTable from "./AuditLogTable"
import AuditLogModal from "./AuditLogModal"
import { exportAuditLog } from "helpers/app-backend/testResult_backend_helper"
import moment from "moment"

const RESOURCE = ModuleIds.Logs

const AuditLog = ({
    auditLog,
    onGetAuditLog,
    loadingAuditLog,
    auditLogTime,
    t,
    paging
}) => {
    const [row, setRow] = useState({})
    const [modal, setModal] = useState(false)
    const [rows, setRows] = useState([])
    const [model, setModel] = useState({
        search: '',
        page: 1,
        size: 10,
        start: new Date().setDate(new Date().getDate() - 1),
        end: new Date()
    })

    useEffect(() => {
        onGetAuditLog(model)
    }, [])

    const toggle = () => {
        setModal(prev => !prev)
    }

    const onRowClick = (e, data) => {
        setRow(data)
        toggle()
    }

    const onSelectCheckbox = (row, isSelected) => {
        const { rowsState, currentRow } = selectCheckboxHandler(
            rows,
            row,
            isSelected
        )
        setRows(rowsState)
        setRow(currentRow)
    }

    const onSelectAllCheckbox = rows => {
        setRows(rows)
        if (rows.length < 1) setRow({})
        else setRow(rows[rows.length - 1])
    }

    const onSubmitFilter = (values) => {
        setModel({ ...model, ...values })
        onGetAuditLog({ ...values, page: 1, size: 10 })
    }

    const onSearch = (searchText) => {
        let val = {
            search: searchText || ''
        }

        setModel({ ...model, ...val })
        onGetAuditLog({ ...model, ...val, page: 1, size: 10 })
    }

    const onSizePerPageChange = size => {
        onGetAuditLog({ ...model, page: 1, size })
        setModel({ ...model, page: 1, size })
    }

    const onPageChange = page => {
        onGetAuditLog({ ...model, page })
        setModel({ ...model, page })
    }

    const onRefreshHandler = () => {
        onGetAuditLog({ ...model, search: '', page: 1, size: 10 })
        setModel({ ...model, search: '', page: 1, size: 10 })
    }

    const onSortHandler = (field, order) => {
        const sortString = `${field}:${order}`
        onGetAuditLog({ ...model, search: model.search, page: 1, size: 10, sort: sortString })
    }

    const onDownloadFile = async () => {
        let payload = { ...model, search: model.search, page: 1, size: 10 }
        payload.startDate = moment(payload.start).format("YYYY-MM-DD HH:mm")
        payload.endDate = moment(payload.end).format("YYYY-MM-DD HH:mm")
        await exportAuditLog(payload);
    }

    return (
        <React.Fragment>
            <TitleAndTable
                resource={RESOURCE}
                table={() => (
                    <AuditLogTable
                        auditLog={auditLog}
                        onSelect={onSelectCheckbox}
                        onSelectAll={onSelectAllCheckbox}
                        onSearch={onSearch}
                        onRefresh={onRefreshHandler}
                        onPageChange={onPageChange}
                        paging={paging}
                        onSort={onSortHandler}
                        onSizePerPageChange={onSizePerPageChange}
                        onSubmitFilter={onSubmitFilter}
                        loading={loadingAuditLog}
                        updatedTime={auditLogTime}
                        onRowClick={onRowClick}
                        onDownloadFile={onDownloadFile}
                        onChangeModel={val => {
                            setModel({ ...model, ...val })
                        }}
                    />
                )}
                external
                subtitle={t("")}
                icon={false}
            />
            <AuditLogModal
                modal={modal}
                toggle={toggle}
                data={row}
            />
        </React.Fragment>
    )
}

AuditLog.propTypes = {
    onGetAuditLog: PropTypes.func,
    t: PropTypes.any,
    paging: PropTypes.any,
    auditLog: PropTypes.any

}

const mapStateToProps = ({ auditLog }) => ({
    auditLog: auditLog.auditLog.auditLog,
    paging: auditLog.auditLog.paging,
    loadingAuditLog: auditLog.auditLog.loadingAuditLog,
    auditLogTime: auditLog.auditLog.auditLogTime,
})

const mapDispatchToProps = dispatch => ({
    onGetAuditLog: payload => dispatch(getAuditLog(payload)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(["message", "common", "hisConnectorPage"])(AuditLog))